import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";

async function getAPIKey() {
  return await httpClient.core.get<string>(`/product-search/api-key`, {
    responseType: "text",
  });
}

export const useGetAPIKey = () => {
  return useQuery({
    queryKey: ["product-search-api-key"],
    queryFn: getAPIKey,
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60, // 1 hour
  });
};
